import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import {
  type AggregateResponseSummary,
  IssueSeverity,
} from '../../../../shared/models';
@Component({
  selector: 'backoffice-aggregate-validations',
  templateUrl: './aggregate-validations.component.html',
  styleUrls: ['./aggregate-validations.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AggregateValidationsComponent {
  @Input() aggregate!: AggregateResponseSummary;

  IssueSeverity = IssueSeverity;
}
